export default __webpack_public_path__ + "static/adobe-669c2fc426c84571a94126e9642b8f16.png";